import React, { useRef, useState, useEffect } from 'react';
import { motion, useScroll, useTransform} from 'framer-motion';
import '../App.css';
import WAX_SEAL from "../assets/sello2.webp";
import pino from "../assets/pino.svg";
import argollas from "../assets/argollas.png"


function WelcomeLetter() {
     const containerRef = useRef(null);
  
  const [isMobile, setIsMobile] = useState(false);

  // Detección básica de móvil para ajustar la escala de la animación final
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end end"]
  });

   

  // --- DEFINICIÓN DE LA COREOGRAFÍA DEL SCROLL ---

  // 1. La tapa se abre (0% a 40% del scroll)
  const flapRotation = useTransform(scrollYProgress, [0.08, 0.9], [0, -180]);

  // 2. Manejo del Z-Index de la tapa.
  // Debe estar muy arriba al inicio, pero "caer" detrás de todo cuando se abre completamente.
  // Usamos un paso abrupto: si el scroll > 0.35, el z-index baja.
  const flapZIndex = useTransform(scrollYProgress, (value) => value > 0.55 ? 1 : 30);
  
  // 3. Movimiento de la carta (empieza a salir al 40%, termina al 90%)
  // En móvil la sacamos más arriba para que se lea mejor.
  const finalYPosition = isMobile ? -180 : -200; 
  const letterY = useTransform(scrollYProgress, [0.08, 0.9], [0, finalYPosition]);
  
  // 4. Escala de la carta para dar énfasis al final
  const letterScale = useTransform(scrollYProgress, [0.6, 1], [0.95, 1.4]);
  
  // 5. CRÍTICO: Z-Index dinámico de la carta.
  // Empieza en 5 (detrás del frente del sobre que es 10).
  // Justo cuando empieza a moverse (0.45), salta a 20 (delante del frente del sobre).
  const letterZIndex = useTransform(scrollYProgress, (value) => value > 0.65 ? 20 : 5);

  // 6. Opacidad del contenido para que aparezca suavemente
  const contentOpacity = useTransform(scrollYProgress, [0.3, 1], [0, 1]);
  const letterScaleY = useTransform(scrollYProgress, [0.08, 0.9], [0.1, 1.0]);


  // 1. Opacidad del Sello: Desaparece rápido al empezar a "romperlo"
  const sealOpacity = useTransform(scrollYProgress, [0, 0.1], [1, 0]);
  return (
    <div className="scroll-container" ref={containerRef}>
        
        <div className="sticky-wrapper">

          <div className='indicador-desliza'>
          <span className="arrow">↓</span>
        </div> 
          {/* Contenedor 3D */}
          <div className="envelope-stage">
            <div className="envelope-wrapper">
              
              {/* TAPA (FLAP) - Se mueve y cambia su z-index */}
              <motion.div 
                className="envelope-flap beige-texture" 
                style={{ 
                  rotateX: flapRotation, 
                  zIndex: flapZIndex 
                }}
              >
             
              
              </motion.div>
              <motion.img 
                src={WAX_SEAL} 
                alt="Sello de lacre"
                className="wax-seal"
                style={{ opacity: sealOpacity }}
              />
              {/* BOLSILLO FRONTAL (FRONT) - Estático, z-index intermedio */}
              <div className="envelope-front beige-texture" />

              <div className="envelope-back beige-texture shadow-inner" />  

              {/* CARTA (LETTER) - Se mueve y salta hacia adelante */}
              <motion.div 
                className="letter white-texture"
                style={{ 
                  y: letterY, 
                  scale: letterScale,
                  scaleY:letterScaleY,
                  zIndex: letterZIndex 
                }}
              >
                <div className="letter-content">
                  <motion.div style={{ opacity: contentOpacity, scaleX:scrollYProgress}}>
                    <p className='texto-serif-md'>NOSOTROS</p>
                    <h1 className='nombres'>Diana  y  Emmanuel</h1>
                    <p className="texto-serif-md">DESEAMOS QUE NOS ACOMPAÑEN A FESTEJAR NUESTRO ENLACE MATRIMONIAL</p>
                    <img src={argollas} className='pino-separador'>
                    </img>
                    <div className="details">
                      <p className='text-md text-cursiva'>Hotel El Paraíso</p>
                      <p className='text-md text-cursiva'>Mineral del Chico, Hidalgo</p>
                      <p className='text-md text-cursiva bold' style={{marginTop: "1rem"}}>16 de mayo de 2026</p>
                    </div>
                  </motion.div>
                </div>
              </motion.div>

              {/* FONDO DEL SOBRE (BACK) - Estático, z-index más bajo */}
              <div className="envelope-back solid-white" />
            </div>
          </div>

        </div>
        
      </div>
  )
}

export default WelcomeLetter